
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/contexts/AuthContext';
import LanguageToggle from '@/components/ui/language-toggle';
import { Button } from '@/components/ui/button';
import EditorialMenu from "./EditorialMenu";

interface EditorialLayoutProps {
  children: React.ReactNode;
}

const EditorialLayout: React.FC<EditorialLayoutProps> = ({ children }) => {
  const { t } = useTranslation();
  const { isAuthenticated, user, signOut } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="w-full bg-white shadow-sm mb-8">
        <div className="max-w-7xl mx-auto px-4 flex items-center justify-between py-4">
          {/* Left side with logo and editorial menu */}
          <div className="flex items-center gap-4">
            <Link to="/proto1" className="block">
              <img 
                src="/lovable-uploads/24339f27-7064-4bc1-a0ed-462456a998ec.png" 
                alt="Beefr Logo" 
                className="h-8 w-auto md:h-12"
              />
            </Link>
            <EditorialMenu />
          </div>
          
          {/* Right side with language toggle and auth */}
          <div className="flex items-center justify-end gap-2">
            <LanguageToggle />
            
            {/* Authentication UI */}
            {isAuthenticated ? (
              <div className="flex items-center gap-2">
                {user?.email && (
                  <span className="text-xs text-muted-foreground hidden md:block">
                    {user.email}
                  </span>
                )}
                <Button 
                  variant="ghost" 
                  size="sm"
                  onClick={signOut}
                  className="text-xs md:text-sm"
                >
                  {t('auth.logOut')}
                </Button>
              </div>
            ) : (
              <Button 
                variant="ghost" 
                size="sm"
                asChild
                className="text-xs md:text-sm"
              >
                <Link to="/auth">{t('auth.logIn')}</Link>
              </Button>
            )}
          </div>
        </div>
      </div>
      
      {/* Page content */}
      {children}
    </div>
  );
};

export default EditorialLayout;
